import { auditLogFactory } from '@eas/common-web';
import { ExportTag } from '@enums';

export const Alog = auditLogFactory({
  url: '/api/tapis/alog',
  reportTag: ExportTag.ALOG_GRID,
});
